import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { BlockUIModule } from "ng-block-ui";
import { BlockUIHttpModule } from "ng-block-ui/http";

import { MainLayoutComponent } from "./main-layout/main-layout.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { LoaderComponent } from "../_shared/loader/loader.component";
import { HttpRequest } from "@angular/common/http";
import { ScrollToTopComponent } from "./scroll-to-top/scroll-to-top.component";
import { LayoutRoutingModule } from "./layout-routing.module";

import { LoadingBarModule } from "@ngx-loading-bar/core";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { NewHomepageModule } from "@app/new-homepage/new-homepage.module";

export function urlFilter(req: HttpRequest<any>): boolean {
  return new RegExp("myProjects").test(req.url);
}

@NgModule({
  imports: [
    CommonModule,
    LayoutRoutingModule,
    RouterModule.forChild([]),
    // BlockUIModule.forRoot({ delayStart: 0, delayStop: 100 }),
    // BlockUIHttpModule.forRoot({
    //   blockAllRequestsInProgress: true,
    //   requestFilters: [urlFilter]
    // }),
    // LoadingBarModule,
    LoadingBarHttpClientModule,
    NewHomepageModule
  ],
  exports: [],
  declarations: [LoaderComponent, MainLayoutComponent, HeaderComponent, FooterComponent, ScrollToTopComponent],
})
export class LayoutModule {}
